
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";

import "@/assets/css/pages/recruit.css";

@Component({})
export default class extends Vue {
  mounted() {
    this.loadFormrunScript();
  }

  initFormrun() {
    (window as any).Formrun._reset()(window as any).Formrun.init(".formrun");
  }

  loadFormrunScript() {
    if ((window as any).Formrun) {
      this.initFormrun();
      return;
    }

    new Promise((resolve, reject) => {
      // (1). 該当スクリプトを動的にロード
      const script = document.createElement("script");
      script.addEventListener("load", resolve);
      script.addEventListener("error", reject);
      script.src = "https://sdk.form.run/js/v2/embed.js";
      document.head.appendChild(script);
    })
      .then(() => {
        this.initFormrun();
      })
      .catch(() => {
        console.log("formrun load error");
      });
  }
}
